import { upsertStyleTag, removeStyleTag } from "../../domStyles";

const ROOT = document.documentElement;
const CLASS = "incluway-word-spacing";
const STYLE_ID = "incluway-word-spacing-style";
const EXCLUDE = "#incluway-widget-root";

function toWordSpacing(multiplier: number) {
  const m = Number.isFinite(multiplier)
    ? Math.max(0, Math.min(3, multiplier))
    : 0;

  return `${(m * 0.12).toFixed(3)}em`;
}

export function setWordSpacing(multiplier: number) {
  if (!multiplier || multiplier <= 0) {
    disableWordSpacing();
    return;
  }

  upsertStyleTag(
    STYLE_ID,
    `
html.${CLASS} :not(${EXCLUDE}):not(${EXCLUDE} *) {
  word-spacing: var(--incluway-word-spacing, 0em) !important;
}
`.trim(),
  );

  ROOT.style.setProperty("--incluway-word-spacing", toWordSpacing(multiplier));
  ROOT.classList.add(CLASS);
}

export function disableWordSpacing() {
  ROOT.classList.remove(CLASS);
  ROOT.style.removeProperty("--incluway-word-spacing");
  removeStyleTag(STYLE_ID);
}
